module.exports = "<input class=\"datepicker\" type=\"text\" data-timepicker=\"true\" data-datepicker=\"true\" data-formatdate=\"d/m/Y\" data-formattime=\"H:i\" data-inline=\"false\" data-mask=\"false\" data-mindate=\"false\" data-maxdate=\"false\" data-startdate=\"25/07/2019\">";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/datepicker/sample.html
// module id = 64
// module chunks = 0